var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.857 10.286c0-.943.759-1.715 1.715-1.715c.955 0 1.714.772 1.714 1.715A1.71 1.71 0 0 0 12 12c1.033 0 1.714-.789 1.714-1.714c0-.943.759-1.715 1.715-1.715c.955 0 1.684.772 1.684 1.715c0 1.05.759 1.692 1.744 1.714c.875 0 1.715.793 1.715 1.714a1.723 1.723 0 0 1-2.938 1.211a1.7 1.7 0 0 1-.491-1.21c0-.944-.759-1.715-1.714-1.715a1.67 1.67 0 0 0-1.715 1.714A1.71 1.71 0 0 1 12 15.428a1.71 1.71 0 0 1-1.714-1.714A1.71 1.71 0 0 0 8.572 12a1.67 1.67 0 0 0-1.715 1.714c0 .943-.741 1.714-1.697 1.714a1.72 1.72 0 0 1-1.731-1.714c0-.934.788-1.714 1.731-1.714a1.66 1.66 0 0 0 1.697-1.714"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyria);
export default __webpack_public_path__ + "static/media/myria.e995c6d98ddb13a4c9bb282441c72fed.svg";
export { ForwardRef as ReactComponent };